import { render, staticRenderFns } from "./Insight.vue?vue&type=template&id=67e15636"
import script from "./Insight.vue?vue&type=script&lang=js"
export * from "./Insight.vue?vue&type=script&lang=js"
import style0 from "./Insight.vue?vue&type=style&index=0&id=67e15636&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports